import Vuex from 'vuex'
import get from 'lodash/get'
import PageValidator from "../Helpers/PageValidator";
import ReadableAnswersFormatter from "../Helpers/ReadableAnswersFormatter";
import SubmitResultsAction from "../Actions/SubmitResultsAction";
import {ViewStates} from "./ViewStates";
import {PersonalizedValues} from "./PersonalizedValues";
import CalculatePersonalizedValues from "../Helpers/CalculatePersonalizedValues";
import {NavigationDirections} from "./NavigationDirections";


const viewStates = ViewStates;
const navigationDirections = NavigationDirections;
const defaultPersonalizedValues = PersonalizedValues;

const getDefaultState = () => {
    return {
        quizData: {},
        questionsGroupedByPage: [],
        submittedAnswers: {},
        currentPageNumber: 1,
        totalPageCount: 1,
        navigationDirection: navigationDirections.FORWARD,

        pageValidationErrors: [],
        pageIsValid: true,

        completedSubmission: {},
        personalizedValues: defaultPersonalizedValues,
        viewState: viewStates.ANSWERING,

        dialogOpened: false
    };
}

export default new Vuex.Store({
    state: getDefaultState(),
    getters: {
       // For calculated/computed results
        questionsForCurrentPage(state){
            return state.questionsGroupedByPage[state.currentPageNumber];
        },
        answerForQuestion: (state) => (questionId) => {
            return get(state.submittedAnswers, questionId, null);
        },
        errorsForQuestion: (state) => (questionId) => {
            return get(state.pageValidationErrors, questionId, null);
        },
        quizDescription(state){
            return state.quizData.description;
        },
        quizMobileDescription(state){
            if(!state.quizData.mobile_description || state.quizData.mobile_description.length === 0){
                return state.quizData.description;
            }
            return state.quizData.mobile_description;
        },
        readableSubmittedAnswers(state){
            return (new ReadableAnswersFormatter(state.questionsGroupedByPage, state.submittedAnswers, state.currentPageNumber)).getAnswers();
        }
    },
    mutations: {
        setQuizData(state, quizData){
            Object.assign(state.quizData, quizData);
            Object.assign(state.submittedAnswers, {});

            state.questionsGroupedByPage = quizData.questions_grouped_by_page;

            //state.currentPageNumber = 1;
            state.totalPageCount = state.quizData.total_pages;
        },
        gotoNextPage(state){
            if (state.currentPageNumber === state.totalPageCount) {
                return;
            }
            state.currentPageNumber++;
            state.navigationDirection = navigationDirections.FORWARD;

            let newPersonalizedValues = (new CalculatePersonalizedValues(state.submittedAnswers, state.quizData.personalisations, defaultPersonalizedValues)).execute();
            Object.assign(state.personalizedValues, newPersonalizedValues);
        },
        gotoPreviousPage(state){
            if (state.currentPageNumber === 1) {
                return;
            }
            state.navigationDirection = navigationDirections.BACKWARD;
            state.currentPageNumber--;
        },
        setAnswer(state, payload){
            Object.assign(state.submittedAnswers, state.submittedAnswers,{[payload.questionId]: payload.answer});
        },
        validatePage(state){
            let questions = state.questionsGroupedByPage[state.currentPageNumber];
            let validator = new PageValidator();
            validator.validate(questions, state.submittedAnswers);

            state.pageIsValid = validator.passed();
            state.pageValidationErrors = validator.getErrors();
        },
        increment(state, newQuiz) {
            state.count++
        },
        setViewState(state, newViewState){
            state.viewState = newViewState
        },
        setCompletedSubmission(state, completedSubmission){
            state.completedSubmission = completedSubmission;
        },
        openDialog(state){
            // Reset quizz if finished previously
            if (state.viewState === viewStates.FINISHED) {
                Object.assign(state, getDefaultState());
            }
            state.dialogOpened = true;
        },
        closeDialog(state){
            state.dialogOpened = false;
        },
    },
    actions: {
        // Can be async
        increment(context) {
            context.commit('increment')
        },
        submitAnswersToServer(context) {
            context.commit('setViewState', viewStates.SENDING);

            let action = new SubmitResultsAction(context.state.quizData.id, context.state.submittedAnswers);
            action.execute().then((data) => {
                // Redirect if necessary
                if(data.redirect_url){
                    window.location.href = data.redirect_url;
                    return;
                }

                context.commit('setCompletedSubmission', data.submission);
                context.commit('setViewState', viewStates.FINISHED);
            }).catch((error) => {
                context.commit('setViewState', viewStates.FAILED);
            });

        }
    }
})
